import { apiSlice } from './apiSlice'
import { gameApiSlice } from './gameSlice'
import { habitsSlice } from './habitsSlice'
import { integrationSlice } from './integrationSlice'
import { socialApiSlice } from './socialSlice'
import { userApiSlice } from './userSlice'

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

export const {
    useGetCategoryResQuery,
    useUpdatePlannerItemMutation,
    useDeletePlannerItemMutation,
    usePutPlannerItemMutation,
    usePutPlannerItemNLPMutation,
    useGetDatedItemsQuery,
    useGetWorkBlockInfoQuery,
    useAddToWorkBlockMutation,
    useRemoveFromWorkBlockMutation,
    usePutCategoryUnitMutation,
    useEditCategoryUnitMutation,
    useRemoveCategoryUnitMutation,
    useInactivateCategoryUnitMutation,
    useGetSmartGoalsOfStretchGoalQuery,
    useGetStretchGoalsQuery,
    useGetStretchGoalsOrderQuery,
    usePutStretchGoalMutation,
    usePutStretchGoalsOrderMutation,
    usePutSmartGoalMutation,
    useRemoveSmartGoalMutation,
    useRemoveStretchGoalMutation,
    useUpdateSmartGoalMutation,
    useGetIdeasQuery,
    usePutIdeaMutation,
    useGetMascotSettingsQuery,
    useUpdateMascotSettingsMutation,
    useGetTinyTasksQuery,
    usePutTinyTasksMutation,
    useGetKanbanSettingsQuery,
    usePutKanbanSettingsMutation,
    useGetMenstrualCycleDataQuery,
    usePutMenstrualCycleLogMutation,
} = apiSlice

export const {
    useGetCurrentLessonQuery,
    useUnlockLessonMutation,
    useGetLessonsInProgressQuery,
    useLazyGetLessonDataQuery,
    useGetLessonDataQuery,
    usePutLessonDataMutation,
    useUpdateLessonDataMutation,
    useGetAchievementQuery,
    useGetAchievementsQuery,
    useGetMissionQuery,
    usePutAchievementMutation,
    useGetFeatureAccessQuery,
    useUpdateFeatureAccessMutation,
    useGetRuleOfThreeQuery,
    useGetRuleOfThreeHistoryQuery,
    useUpdateRuleOfThreeMutation,
    usePutRuleOfThreeMutation,
    useGetRuleOfThreeSettingsQuery,
    useLazyGetRuleOfThreeQuery,
    useClaimLessonChallengeRewardMutation,
    useGetWalletQuery,
    useGetNextLessonChoicesQuery,
    useFetchTaskCountsQuery,
} = gameApiSlice

export const {
    useGetHabitsQuery,
    useGetHabitQuery,
    usePutHabitMutation,
    usePutHabitEntryMutation,
    useGetHabitsResQuery,
    useGetHabitsOrderQuery,
    usePutHabitsOrderMutation,
    useDeleteHabitMutation,
} = habitsSlice

export const {
    useResetExternalCalendarSyncMutation,
    useExternalCalendarIsEnabledQuery,
    useDisableExternalCalendarMutation,
    useGetGoogleCalendarSettingsQuery,
    useUpdateGoogleCalendarSettingsMutation,
    useGetAppleCalendarSettingsQuery,
    useUpdateAppleCalendarSettingsMutation,
} = integrationSlice

export const {
    useGetMobileQuery,
    useGetFriendsQuery,
    useGetFriendRequestsQuery,
    useGetProfileQuery,
    usePutProfileMutation,
    useGetFriendProfileQuery,
    useGetShareLinksQuery,
    useGetShareLinkSettingsQuery,
    usePutShareLinkMutation,
    useRemoveShareLinkMutation,
    useSendMessagesMutation,
    useAcceptFriendRequestMutation,
    useRejectFriendRequestMutation,
    useGetMailQuery,
    useSetMessageAsReadMutation,
} = socialApiSlice

export const {
    useGetUserQuery,
    usePatchUserMutation,
    useEditNoteMutation,
    useGetGeneralThemeCustomizationsQuery,
    useUpdateGeneralThemeCustomizationsMutation,
} = userApiSlice

export const fullApiSlice = userApiSlice
